<div class="row align-items-center">
  <div class="col-lg-6 d-none d-md-block" data-aos="fade-right">
    <img src="../../../assets/images/IMG_3317treebwresized.jpg" class="home-image scrolling-image"
      alt="the band standing in front of a tree in an open landscape in the Ardennes" />
    </div>
    <div class="col-lg-6" data-aos="fade-left">
      @if (filteredShows.length != 0) {
        <h2 class="text-center">Upcoming shows</h2>
      }
      @if (filteredShows.length === 0) {
        <div class="alert alert-info text-center m-5">
          No upcoming public shows at the moment.<br />
          If you want to book us or have questions, <a href="/contact">contact us</a>!
        </div>
      }
      @if (filteredShows.length > 0) {
        <div>
          @for (show of filteredShows; track show; let last = $last) {
            <div>
              <app-show-small [show]="show"></app-show-small>
              @if (!last) {
                <hr class="styled-line" />
              }
            </div>
          }
        </div>
      }
    </div>
  </div>